import { render, staticRenderFns } from "./FormatsFeed.vue?vue&type=template&id=15f482c8&scoped=true&"
import script from "./FormatsFeed.vue?vue&type=script&lang=js&"
export * from "./FormatsFeed.vue?vue&type=script&lang=js&"
import style0 from "./FormatsFeed.vue?vue&type=style&index=0&id=15f482c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f482c8",
  null
  
)

export default component.exports